<template>
  <div>
    <v-menu min-width="200" transition="scroll-y-transition"
      offset-y
      bottom>
      <template v-slot:activator="{ on }">
        <v-chip outlined color="primary" v-on="on">
          <v-icon small class="mr-1">
            mdi-rhombus-split-outline
          </v-icon>
          {{ currentCollection ? currentCollection.name : '' }}
        </v-chip>
      </template>
      <v-list nav>
        <v-list-item-group v-model="currentCollectionIndex" color="primary">
          <v-list-item v-bind:disabled="currentCollectionIndex === i" class="px-5"
            v-for="(collection, i) in collectionList" :key="i">
            <v-list-item-icon>
              <v-icon small>mdi-rhombus-split-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              {{ collection.name }}
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'NavCollection',
  data: () => ({
    showSuccess: false
  }),
  computed: {
    currentCollectionIndex: {
      get () {
        return this.$store.getters['collectionContext/currentCollectionIndex']
      },
      set (index) {
        this.$store.dispatch('collectionContext/setCurrentCollectionIndex', index)
      }
    },
    currentCollection: {
      get () {
        return this.$store.getters['collectionContext/currentCollection']
      }
    },
    collectionList () {
      return this.$store.getters['collectionContext/collectionList']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/collection/NavCollection.vue